import { makeHook } from "../../utils/makeSingleArgHook";
import getSMA, { getUrl } from "../requests/getSMA";
import { SMAAsset, SMAAssetId } from "../requests/Types";
export { SMAAsset, SMAAssetId };
export const keyMaker = (assetId) => [getUrl(assetId)];
const useSMAAsset = makeHook(getSMA, keyMaker);
export default useSMAAsset;
//# sourceMappingURL=useSMAAsset.js.map